import { render } from "./NewCampaignButton.vue?vue&type=template&id=9cf68d0c&scoped=true"
import script from "./NewCampaignButton.vue?vue&type=script&lang=js"
export * from "./NewCampaignButton.vue?vue&type=script&lang=js"

import "./NewCampaignButton.vue?vue&type=style&index=0&id=9cf68d0c&scoped=true&lang=css"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cf68d0c"]])

export default __exports__